import {types, IDisposer} from 'mobx-state-tree';
import AuthCallbackViewModel from './types/AuthCallbackViewModel';
import LoggerAwareViewModel from './types/LoggerAwareViewModel';
import ReactLifecyclePresenter from './types/ReactLifecyclePresenter';
import SingletonAwareViewModel from './common/SingletonAwareViewModel';
import {SocketWrapper} from './common/SocketWrapper';
import {isMobile} from 'react-device-detect';
import {AuthUserType} from './types/UserInfo';

const BasePresenter = types
    .compose(ReactLifecyclePresenter, AuthCallbackViewModel, LoggerAwareViewModel, SingletonAwareViewModel)
    .named('BasePresenter')
    .volatile(() => ({
        disposers: [] as IDisposer[],
    }))
    .views((self) => ({
        get authUser(): AuthUserType | undefined {
            return self.authUserStore.userInfo;
        },
        get isUserAuthenticated() {
            return this.authUser != null && !this.authUser.isAnonymous;
        },
        get socketWrapper(): SocketWrapper {
            return self.rootStore.socketWrapper;
        },
        get isMobile(): boolean {
            if (typeof isMobile === 'undefined') {
                self.logger.log('isMobile is not set for ', self.toString());
            }
            return isMobile;
        },
        get containerClassName(): string | undefined {
            return;
        },
        get isFooterVisible() {
            return true;
        },
    }))
    .actions((self) => ({
        afterCreate() {},
        userDataDidGet() {},
        beforeDestroy() {
            self.disposers.forEach((d) => d());
        },
    }));

export default BasePresenter;
